import * as React from 'react';
import { withAuthContext } from 'containers/AccessControl/WithAuthContext';
import { translate } from 'react-i18next';
import * as c from 'models/constants';
import ReviewScore from 'components/FormControls/ReviewScore';
import ReviewBox from 'components/FormControls/ReviewBox';
import ReviewList from 'components/ItemList/ReviewList';
import { IStore } from 'redux/IStore';
const { connect } = require('react-redux');

interface IProps {
	shopId: string;
	userId: string;
	t?: (key: string) => string;

	// state props
	averageRating?: number;
	votes?: number;
}

@connect((state: IStore) => ({
	averageRating: state.usercard.usercard.averageRating,
	votes: state.usercard.usercard.votes,
}))
@translate(c.DEFAULT_TRANSLATION_NAMESPACE)
class Reviews extends React.Component<IProps, {}> {
	constructor(props) {
		super(props);
	}
	render() {
		const { averageRating, votes, shopId } = this.props;
		// TODO Show ReviewBox only to shops that can leave review to the customer
		return (
			<div className="reviews">
				<ReviewScore averageRating={averageRating} votes={votes} />
				<ReviewBox shopId={shopId} />
				<ReviewList />
			</div>
		);
	}
}

export default withAuthContext(Reviews);
